import React, { useState } from "react";
import SaveChanges from "./saveChanges";
import { useParams } from "react-router-dom";
import WhiteLoading from "./whiteLoading";
import FormSelect from "./formSelect";
import Info from "./info";

const DeleteFormForm = (props) => {
    const [text, setText] = useState("Are you sure you want to delete a PDF form?");
    const [requestLifeCycle, setRequestLifeCycle] = useState(false);
    const { courseCode, assessmentCode } = useParams();
    const [index, setIndex] = useState(0);

    const resetForm = () => {
        props.updateDeleteForm(false);
    }

    const submitForm = async (e) => {
        e.preventDefault();

        if (requestLifeCycle) {
            return;
        }

        const url = process.env.REACT_APP_EVALUATION_API_URL + `/delete-assessment-form/${courseCode}/${assessmentCode}/${props.uuids[index]}/${props.isProgramming}`

        const urlOptions = {
            method: "POST",
            credentials: "include"
        }

        try {
            setRequestLifeCycle(true)
            const res = await fetch(url, urlOptions);
            const data = await res.json();
            
            if (res.status === 200) {
                setText("Evaluation Deleted")              
                props.updateDeleteForm(false);
                props.updateAssessmentInformation((prev) => {
                    return {
                        ...prev,
                        formIds: props.uuids.filter((uuid) => uuid !== props.uuids[index])
                    }
                })
            } else if (res.status === 409) {
                setText("Evaluation cannot have zero forms")
            } else if (res.status === 404) {
                setText("Evaluation or form not found")
            } else if (res.status === 401) {
                setText("Authentication error")
                window.location.href = process.env.REACT_APP_401_REDIRECT_URL;
            } else {
                setText("Status Code: " + res.status + " Error: " + data.detail)
            }
            
        } catch (error) {
            setText("Error: " + error.message)
            console.log(error);
        } finally {
            setRequestLifeCycle(false)
        }
    }

    function updateIndex(index) {
        setIndex(index);
    }

    return (
        <>
            <div className="black-back" onClick={ () => {props.updateDeleteForm(false)} }>

            </div>
            <div className="add-a-course-form-container">
                <div className="add-a-course-form-content-container">
                    <form className="form-width">
                        <div className="add-course-title">
                            Delete Form
                        </div>
                        <div className="account-settings-content">
                            <div className="required-container">
                                All Fields Required
                            </div>   
                            <div className="banner">
                                {
                                    requestLifeCycle 

                                    ?
                                    
                                    <>
                                        <WhiteLoading />
                                    </>

                                    :

                                    <div className="banner-info">
                                        <Info />
                                        { text }
                                    </div>

                                }
                            </div>
                            <FormSelect uuids={props.uuids} updateValue={updateIndex} value={index}/>
                            <SaveChanges left="Cancel" right={{ small : "Delete", large : "Delete" }} resetForm={resetForm} submitForm={submitForm}/> 
                        </div>
                    </form> 
                </div>
            </div>
        </>
    );
}

export default DeleteFormForm;